export default __webpack_public_path__ + "static/media/login-sidebar-bg.544f4eac.png";